"use strict";(()=>{var Bt=Object.defineProperty;var Wt=(e,t,s)=>t in e?Bt(e,t,{enumerable:!0,configurable:!0,writable:!0,value:s}):e[t]=s;var kt=(e,t,s)=>Wt(e,typeof t!="symbol"?t+"":t,s);var St=(e,t,s)=>new Promise((i,a)=>{var c=p=>{try{d(s.next(p))}catch(u){a(u)}},l=p=>{try{d(s.throw(p))}catch(u){a(u)}},d=p=>p.done?i(p.value):Promise.resolve(p.value).then(c,l);d((s=s.apply(e,t)).next())});var Z=class{constructor(t){this.container=t,this.tabList=this.container.querySelector(".js-tablist"),this.tabLinks=this.container.querySelectorAll(".js-tablist__link"),this.tabPanels=this.container.querySelectorAll(".js-tabcontent"),this.init()}init(){if(!this.tabList||!this.tabLinks.length||!this.tabPanels.length){console.warn("CustomTabs: Required elements not found",{tabList:!!this.tabList,tabLinks:this.tabLinks.length,tabPanels:this.tabPanels.length});return}this.setupAccessibility(),this.bindEvents(),this.activateFirstTab()}setupAccessibility(){this.tabList.setAttribute("role","tablist"),this.tabLinks.forEach((t,s)=>{let i=this.tabPanels[s],a=`tab-${this.container.id||"custom"}-${s}`,c=`panel-${this.container.id||"custom"}-${s}`;t.setAttribute("role","tab"),t.setAttribute("id",a),t.setAttribute("aria-selected","false"),t.setAttribute("aria-controls",c),t.setAttribute("tabindex","-1"),i&&(i.setAttribute("role","tabpanel"),i.setAttribute("id",c),i.setAttribute("aria-labelledby",a),i.setAttribute("aria-hidden","true"),i.setAttribute("tabindex","0"))})}bindEvents(){this.tabLinks.forEach(t=>{t.addEventListener("click",s=>{s.preventDefault(),this.activateTab(t)}),t.addEventListener("keydown",s=>{this.handleKeydown(s,t)})})}handleKeydown(t,s){let i=Array.from(this.tabLinks).indexOf(s),a;switch(t.key){case"ArrowLeft":t.preventDefault(),a=this.tabLinks[i-1]||this.tabLinks[this.tabLinks.length-1],this.activateTab(a);break;case"ArrowRight":t.preventDefault(),a=this.tabLinks[i+1]||this.tabLinks[0],this.activateTab(a);break;case"Home":t.preventDefault(),this.activateTab(this.tabLinks[0]);break;case"End":t.preventDefault(),this.activateTab(this.tabLinks[this.tabLinks.length-1]);break}}activateTab(t){let s=Array.from(this.tabLinks).indexOf(t);if(!this.tabPanels[s]){console.warn("CustomTabs: Panel not found for tab",t);return}this.tabLinks.forEach((a,c)=>{let l=c===s;a.setAttribute("aria-selected",l),a.setAttribute("tabindex",l?"0":"-1"),l?a.setAttribute("data-selected","1"):a.removeAttribute("data-selected")}),this.tabPanels.forEach((a,c)=>{let l=c===s;a.setAttribute("aria-hidden",!l),l?a.removeAttribute("tabindex"):a.setAttribute("tabindex","-1")}),t.focus()}activateFirstTab(){let t=this.tabLinks[0];t&&this.activateTab(t)}activateTabByIndex(t){let s=this.tabLinks[t];s&&this.activateTab(s)}activateTabById(t){let s=this.container.querySelector(`#${t}`);s&&this.activateTab(s)}};function N(){document.querySelectorAll(".js-tabs").forEach(t=>{new Z(t)})}document.readyState==="loading"?document.addEventListener("DOMContentLoaded",N):N();var Ht=e=>{class t extends HTMLElement{constructor(){var i,a,c,l;super(),this.header=e,this.detailsElem=this.querySelector("details"),this.summaryElem=(i=this.detailsElem)==null?void 0:i.querySelector("summary"),this.megaMenu=(a=this.summaryElem)==null?void 0:a.nextElementSibling,this.megaMenuList=(c=this.megaMenu)==null?void 0:c.querySelector("[data-mega-menu-level-2-list]"),this.level2Links=(l=this.megaMenuList)==null?void 0:l.querySelectorAll(".header__menu-item--level-2"),this.megaMenuBarHeight=getComputedStyle(this.header).getPropertyValue("--megamenu-level-2-bar-height")}connectedCallback(){this.initLevel1Listeners(),this.initLevel2Listeners(),this.openOnPageLoad()}initLevel1Listeners(){this.summaryElem.addEventListener("click",i=>{var c;i.preventDefault();let a=this.header.querySelector("custom-header-menu .open");this.detailsElem.classList.contains("open")||(this.summaryElem.setAttribute("aria-expanded",!0),this.detailsElem.setAttribute("open",!0),requestAnimationFrame(()=>{this.detailsElem.classList.add("open")})),a&&a!==this.detailsElem&&(a.classList.remove("open"),(c=a.querySelector("summary"))==null||c.setAttribute("aria-expanded",!1),requestAnimationFrame(()=>{a.removeAttribute("open")})),requestAnimationFrame(()=>{var l;(l=this.level2Links[0])==null||l.dispatchEvent(new MouseEvent("mouseenter"))}),e.classList.contains("section-header--scrolling-down")&&e.scrollController.triggerDirection("up")})}initLevel2Listeners(){var i,a;(i=this.level2Links)==null||i.forEach(c=>{c.addEventListener("mouseenter",()=>{var p;let l=c.nextElementSibling,d=l?`${l.scrollHeight+48}px`:this.megaMenuBarHeight;this.closeExpandedLevel2Menu(),(p=c.closest("li"))==null||p.classList.add("is-expanded"),this.megaMenuList&&(this.megaMenuList.style.height=d)})}),(a=this.megaMenuList)==null||a.addEventListener("mouseleave",()=>{this.megaMenuList.style.height=`${this.megaMenuBarHeight}`,this.closeExpandedLevel2Menu()})}closeExpandedLevel2Menu(){var a;let i=(a=this.megaMenuList)==null?void 0:a.querySelector(".is-expanded");i==null||i.classList.remove("is-expanded")}openOnPageLoad(){if(!this.detailsElem||!this.summaryElem)return;let i=sessionStorage.getItem("lastClickedMenuId");if(!i){let a=this.header.querySelector("[data-header-menu-id]");i=a==null?void 0:a.getAttribute("data-header-menu-id")}this.detailsID=this.detailsElem.getAttribute("data-header-menu-id"),i===this.detailsID&&(this.detailsElem.setAttribute("open",!0),this.detailsElem.classList.add("open"),this.summaryElem.setAttribute("aria-expanded","true"))}}customElements.get("custom-header-menu")||customElements.define("custom-header-menu",t)},Vt=e=>{let t=0,s=null,i=!1,a=20,c=l=>{l!==s&&(s=l,e(l))};return window.addEventListener("scroll",()=>{i||(requestAnimationFrame(()=>{let l=window.scrollY;if(Math.abs(l-t)>a){let p=l>t?"down":"up";c(p),t=l}i=!1}),i=!0)},{passive:!0}),{triggerDirection:l=>{c(l),t=window.scrollY}}},Nt=e=>{Ht(e);let t=()=>{let l=window.matchMedia("(max-width: 989px)").matches?"[data-header-drawer-nav]":"[data-header-nav]",d=e.querySelector(l),p=d==null?void 0:d.querySelectorAll("a");p==null||p.forEach(u=>{u.addEventListener("click",()=>{let h=u.closest("[data-header-menu-id]");if(!h)return;let b=h.getAttribute("data-header-menu-id");sessionStorage.setItem("lastClickedMenuId",b)})})};t();let s=window.matchMedia("(max-width: 989px)");if(!s.matches){let l=Vt(d=>{e.classList.remove("section-header--scrolling-up","section-header--scrolling-down"),e.classList.add(`section-header--scrolling-${d}`)});e.scrollController=l}let i=!1,a=()=>{let l=sessionStorage.getItem("lastClickedMenuId");if(!l)return;let d=e.querySelector(`[data-header-menu-id="${l}"]`);if(!d)return;let p=d.id,u=e.querySelector(`[aria-controls="${p}"]`);u==null||u.click()},c=()=>{let l=e.querySelector("[data-header-drawer-nav]"),d=l==null?void 0:l.querySelectorAll("details"),p=(u,h,b)=>{!u||!h||!b||(u.classList.remove("open"),b.addEventListener("transitionend",function S($){$.propertyName==="grid-template-rows"&&(u.removeAttribute("open"),h.setAttribute("aria-expanded",!1),b.removeEventListener("transitionend",S))}))};d==null||d.forEach(u=>{let h=u.querySelector("summary"),b=h==null?void 0:h.nextElementSibling;!h||!b||h.addEventListener("click",S=>{var C;S.preventDefault();let $=u.classList.contains("open"),k=(C=h.closest("[data-menu-drawer-menu]"))==null?void 0:C.querySelector("details.open");if(k&&k!==u){let L=k.querySelector("summary"),T=L==null?void 0:L.nextElementSibling;p(k,L,T)}$?p(u,h,b):(u.setAttribute("open",!0),h.setAttribute("aria-expanded",!0),requestAnimationFrame(()=>{u.classList.add("open"),k&&setTimeout(()=>{let L=u.getBoundingClientRect();L.top>=0&&L.top<=window.innerHeight||u.scrollIntoView({behavior:"smooth"})},350)}))})})};s.matches&&(a(),c(),i=!0),s.addEventListener("change",l=>{!l.matches||i||(t(),a(),c())})},Lt=Nt;var Dt=({sdkUrl:e,serverUrl:t,clientCode:s,apiKey:i,storeId:a})=>e&&t&&s&&i&&a,Ut=({enable:e=!1})=>e,jt=({enable:e,serverUrl:t,clientCode:s,apiKey:i,storeId:a})=>{var d,p,u,h;if(!e||!t||!s||!i||!a)return;let c=(d=window.theme.locale.isoCode)!=null?d:"en",l=(p=window.theme.localization.country)!=null?p:"NZ";window.Tagalys.setConfiguration({api:{serverUrl:t,credentials:{clientCode:s,apiKey:i},storeId:a},locale:`${c}-${l}`,currency:{displayFormatter:"{{currencyLabel}}{{value}}",code:(u=window.theme.localization.currency)!=null?u:"NZD",label:(h=window.theme.localization.currencySymbol)!=null?h:"$",fractionalDigits:2,forceFractionalDigits:!0},analyticsStorageConsentProvided(){return!0},track:!0})},Qt=({enable:e,storefrontApiAccessToken:t})=>{var i,a;if(!e)return;let s=[{namespace:"card",key:"badge"},{namespace:"card",key:"message"}];window.Tagalys.setPlatformConfiguration({platform:"Shopify",countryCode:(i=window.theme.localization.country)!=null?i:"NZ",baseCountryCode:(a=window.theme.localization.baseCountry)!=null?a:"NZ",useStorefrontAPIForSecondaryMarkets:!!t,waitForStorefrontAPI:!!t,storefrontAPI:{accessToken:t,myShopifyDomain:window.Shopify.shop},metafields:{products:s}})},W=e=>{let t=setInterval(()=>{if(!window.Tagalys||!window.tagalysReady){window.console.error("TWP | onTagalysReady | Tagalys is not ready");return}clearInterval(t),typeof e=="function"&&e()},150)},xt=()=>{let e=window.theme.tagalys;if(!e||!Dt(e)||!Ut(e))return;let t=setInterval(()=>{if(!window.Tagalys){window.console.error("TWP | tagalysInit | Tagalys has not loaded");return}clearInterval(t),jt(window.theme.tagalys),Qt(window.theme.tagalys),window.tagalysReady=!0,document.dispatchEvent(new Event("tagalys:ready"))},150)};var It=e=>{let t=window.theme.locale.rootUrl==="/"?"":window.theme.locale.rootUrl;return`${window.location.origin}${t}/products/${e.handle}`},G=e=>{if(!e)return"";let t=document.createElement("textarea");return t.innerHTML=e,t.value};var J=(e,t,s,i)=>{if(!e||!(t||s)||t&&typeof t!="number"||s&&typeof s!="number"||i&&typeof i!="string")return null;try{let a=new URL(e,window.location.origin),c=a.searchParams,l=c.get("width"),d=c.get("height"),p=c.get("crop");return!s&&d&&c.delete("height"),!t&&l&&c.delete("width"),!i&&p&&c.delete("crop"),t&&c.set("width",t),s&&c.set("height",s),i&&c.set("crop",i),a.href}catch(a){return null}};var Zt=(e,t,s,i=!0,a="")=>{let c=[160,320,480,640,800,960,1120,1280,1440,1600,1920,2240,2560],l="";return c.forEach((d,p)=>{if(d>s)return;let u=J(e.src,d);p>0&&(l+=", "),l+=`${u} ${d}w`}),`
    <img
      class="component-image__image"
      src="${J(e.src,480)}"
      srcset="${l}"
      loading="${i?"lazy":"eager"}"
      sizes="${a}"
      width="${e.width}"
      height="${e.height}"
      alt="${t}"
    />`},V=Zt;var Gt=(e,t)=>{var S,$,k;let s="2-3",i="1120",a="(min-width: 61.875rem) 26.5vw, (min-width: 48rem) 35vw, 90vw",c=e.title,l=($=(S=window.theme)==null?void 0:S.productCard)==null?void 0:$.showSecondaryImages,d=e.images,p=d[0],u=(k=p==null?void 0:p.alt)!=null?k:c,h=d.length>1?`${V(p,u,i,!0,a,s)}
    ${V(d[1],u,i,!0,a,s)}`:`
    ${V(p,u,i,!0,a,s)}`,b="";if(l&&e.images.length>1){let C="";e.images.forEach((L,T)=>{var B;if(T===0)return;let F=(B=L.alt)!=null?B:c;C+=`<div class="product-card__slide"><a href=${t}>${V(L,F,i,!0,a,s)}</a></div>`}),b=`<div class="product-card__slider" data-slider>
      <div class="product-card__slide">${h}</div>
      ${C}
    </div>`}return b||h},Ct=Gt;var Pt=e=>{var s,i,a;let t=(s=e.tags)==null?void 0:s.some(c=>c.toLowerCase()==="notify-me");return((a=(i=window.theme)==null?void 0:i.notifyMe)==null?void 0:a.enable)&&t},K=e=>{var t;return(t=e.options_with_values)==null?void 0:t.find(s=>s.name==="Size")},Jt=e=>{var a,c,l;let t=K(e),s=Pt(e),i=((l=(c=(a=window.theme)==null?void 0:a.strings)==null?void 0:c.product)==null?void 0:l.oneSize)||"One Size";if(!t){let d=e.variants[0],p=!d.available;return`
      <button
        class="quick-add-inline-desktop__size-btn ${p?"quick-add-inline-desktop__size-btn--sold-out":""}"
        data-variant-id="${d.id}"
        data-size="${i}"
        data-product-id="${e.id}"
        type="button"
        ${p&&!s?'disabled aria-disabled="true"':""}
        ${p&&s?`data-notify-me-trigger data-variant-id-notify="${d.id}"`:""}
        aria-label="${p&&s?`Notify me when ${i} is back in stock`:`Add ${i} to cart`}"
      >
        <span class="quick-add-inline-desktop__size-text${p&&s?" quick-add-inline-desktop__size-text--strikethrough":""}">${i}</span>
        ${p&&s?`
          <span class="quick-add-inline-desktop__notify-icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
              <rect x="3.92857" y="4.42857" width="9.14286" height="7.14286" stroke="#B8B9BA" stroke-width="0.857143"/>
              <path d="M3.75 5.42859C4.15 5.42859 7.16667 7.42859 8.5 8.28573L13.25 5.42859" stroke="#B8B9BA" stroke-width="0.857143"/>
            </svg>
          </span>
        `:'<span class="quick-add-inline-desktop__success-icon" aria-hidden="true">\u2713</span>'}
      </button>
    `}return t.values.map(d=>{let p=e.variants.find(h=>h.option1===d||h.option2===d||h.option3===d);if(!p)return"";let u=!p.available;return`
      <button
        class="quick-add-inline-desktop__size-btn ${u?"quick-add-inline-desktop__size-btn--sold-out":""}"
        data-variant-id="${p.id}"
        data-size="${d}"
        data-product-id="${e.id}"
        type="button"
        ${u&&!s?'disabled aria-disabled="true"':""}
        ${u&&s?`data-notify-me-trigger data-variant-id-notify="${p.id}"`:""}
        aria-label="${u&&s?`Notify me when size ${d} is back in stock`:`Add size ${d} to cart`}"
      >
        <span class="quick-add-inline-desktop__size-text${u&&s?" quick-add-inline-desktop__size-text--strikethrough":""}">${d}</span>
        ${u&&s?`
          <span class="quick-add-inline-desktop__notify-icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
              <rect x="3.92857" y="4.42857" width="9.14286" height="7.14286" stroke="#B8B9BA" stroke-width="0.857143"/>
              <path d="M3.75 5.42859C4.15 5.42859 7.16667 7.42859 8.5 8.28573L13.25 5.42859" stroke="#B8B9BA" stroke-width="0.857143"/>
            </svg>
          </span>
        `:'<span class="quick-add-inline-desktop__success-icon" aria-hidden="true">\u2713</span>'}
      </button>
    `}).join("")},Kt=(e,t)=>{var l,d,p,u;let s=K(e),i=Pt(e),a=((p=(d=(l=window.theme)==null?void 0:l.strings)==null?void 0:d.product)==null?void 0:p.oneSize)||"One Size",c={id:e.id,title:e.title,vendor:e.vendor,price:t.formatCurrency(e.price),compareAtPrice:e.compare_at_price?t.formatCurrency(e.compare_at_price):null,handle:e.handle,aspectRatio:2/3,images:((u=e.images)==null?void 0:u.slice(0,5).map(h=>({url:h.src,srcset:`${h.src}?w=250 250w, ${h.src}?w=500 500w, ${h.src}?w=750 750w, ${h.src}?w=1000 1000w`,alt:h.alt||"",width:h.width,height:h.height})))||[],sizes:s?s.values.map(h=>{let b=e.variants.find(S=>S.option1===h||S.option2===h||S.option3===h);return b?{value:h,variantId:b.id,available:b.available}:null}).filter(Boolean):[{value:a,variantId:e.variants[0].id,available:e.variants[0].available}],variants:e.variants.map(h=>({id:h.id,title:h.title,available:h.available})),notifyMeEnabled:i};return`
    <button
      class="quick-add-inline-mobile__trigger"
      aria-label="Quick add ${e.title}"
      data-quick-add-trigger
      data-product-id="${e.id}"
      data-product-json='${JSON.stringify(c).replace(/'/g,"&#39;")}'
      type="button"
    >
      <svg class="icon icon--plus" viewBox="0 0 24 24" width="24" height="24">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6 5H11.4V11.4H5V12.6H11.4V19H12.6V12.6H19V11.4H12.6V5Z" fill="currentColor"/>
      </svg>
    </button>
  `},Yt=(e,t)=>{var p,u;if(!((u=(p=window.theme)==null?void 0:p.quickAdd)!=null&&u.enable)||!e.variants||e.variants.length===0)return"";let s=K(e),i=s?s.values.length:1,a=!1,c=!1,l=!1;s&&s.values.forEach(h=>{h.length>=7?(l=!0,c=!0,a=!0):h.length>=6?(c=!0,a=!0):h.length>=4&&(a=!0)});let d="";return i===1?d=" quick-add-inline-desktop__sizes--one-size":l?d=" quick-add-inline-desktop__sizes--two-columns":i<=3?d=" quick-add-inline-desktop__sizes--flex":i===4&&c?d=" quick-add-inline-desktop__sizes--three-columns":i===4?d=" quick-add-inline-desktop__sizes--flex":a&&i===5?d=" quick-add-inline-desktop__sizes--three-columns":a&&i>5&&(d=" quick-add-inline-desktop__sizes--four-columns"),`
    <quick-add-inline
      class="quick-add-inline"
      data-product-id="${e.id}"
      data-section-id="tagalys-${e.id}"
    >
      <div class="quick-add-inline__desktop small-hide">
        <div class="quick-add-inline-desktop">
          <div class="quick-add-inline-desktop__sizes${d}">
            ${Jt(e)}
          </div>
        </div>
      </div>
      <div class="quick-add-inline__mobile medium-up-hide">
        ${Kt(e,t)}
      </div>
    </quick-add-inline>
  `},Xt=e=>{var s;if(!(e!=null&&e.length))return"";let t=e.filter(i=>i.includes("label:"));return t.length===0?"":`
    <div class="card__badge ${(s=window.theme)==null?void 0:s.badgePosition}">
      ${t.map(i=>`<span class="badge">${i.replace("label:","")}</span>`).join("")}
    </div>
  `},es=e=>{var s,i;if(!((i=(s=window.theme)==null?void 0:s.wishlist)!=null&&i.twpEnable))return"";let t=e;return t.featured_image=e.images[0].src,`
    <div class="osc-css wrapper-button-collection">
      <div
        class="button-collection-wishlist button-${e.id}"
        data-product-id="${e.id}"
        data-has-only-variant="${e.has_only_default_variant}"
        data-product-title="${e.title}"
      >
        <span class="button-icon"></span>
        <span class="button-text"></span>
      </div>
    </div>
    <script type="application/json" id="ProductJson-${e.id}">
      ${JSON.stringify(e)}
    <\/script>
    <script type="application/json" id="OptionJson-${e.id}">
      ${JSON.stringify(e.options_with_values)}
    <\/script>
  `},ts=e=>{var t,s;return(s=(t=e==null?void 0:e.card)==null?void 0:t.message)!=null&&s.value?`<div class="card__message caption">${e.card.message.value}</div>`:""},ss=e=>e?`
    <span class="visually-hidden">Vendor</span>
    <div class="caption-with-letter-spacing">${e}</div>
  `:"",is=(e,t,s,i)=>{var l,d,p,u,h,b;let a=t.isProductOnSale(i,s);return e.price_varies?`
      <span>
        ${(((p=(d=(l=window.theme)==null?void 0:l.strings)==null?void 0:d.product)==null?void 0:p.priceFrom)||"From {{ price }}").replace("{{ price }}",t.formatCurrency(e.price_min||s))}
      </span>
    `:`
    ${a?`
    <span class="visually-hidden">${((b=(h=(u=window.theme)==null?void 0:u.strings)==null?void 0:h.product)==null?void 0:b.regularPrice)||"Regular price"}</span>
    <s data-compare-price>${t.formatCurrency(i)}</s>
  `:""}
    <span data-product-price ${a?'class="product-card__sale-price"':""}>
      ${t.formatCurrency(s)}
    </span>
  `},as=(e,t)=>{let i=t.getTemplateOptions("product").productPageUrl(e),a=t.getPrice?t.getPrice(e):e.price,c=t.getCompareAtPrice?t.getCompareAtPrice(e):e.compare_at_price,l=t.isProductOnSale(e.compare_at_price,e.price);return`
    <div class="card-wrapper product-card-wrapper underline-links-hover product-card-wrapper-TWP">
      ${es(e)}
      <div class="card card--standard card--media" style="--ratio-percent: 128.47826086956522%">
        <div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent: 128.47826086956522%">
          <a href=${i} class="card__content full-unstyled-link">
            <div class="card__media">
              <div class="media media--transparent ${e.images.length>1?"media--hover-effect":""}">
                ${Ct(e,i)}
                <span class="visually-hidden">${e.title}</span>
              </div>
            </div>
            ${Xt(e.tags)}
          </a>
          ${Yt(e,t)}
        </div>
        <div class="card__content">
          <div class="card__information">
            ${ss(e.vendor)}
            <h3 class="card__heading">
              <a class="full-unstyled-link" href=${i}>${e.title}</a>
            </h3>
            <div class="card-information">
              <span class="caption-large light"></span>
              <div class="price ${l?"price--on-sale":""}">
                <div class="price__container">
                  ${is(e,t,a,c)}
                </div>
              </div>
              ${ts(e.metafields)}
            </div>
          </div>
        </div>
      </div>
    </div>
  `},D=as;var rs=(e,t)=>{var d,p,u,h,b,S;let s=(d=t==null?void 0:t.dataset)==null?void 0:d.sectionId,i=(p=t==null?void 0:t.dataset)==null?void 0:p.title,a=(h=(u=t==null?void 0:t.dataset)==null?void 0:u.headingSize)!=null?h:"h5",c=(b=t==null?void 0:t.dataset)==null?void 0:b.buttonLabel,l=(S=t==null?void 0:t.dataset)==null?void 0:S.buttonUrl;return{widget:{options:{limit:e,displayFormat:"grid",includeTagalysCSS:!1},render:($,k)=>{let C=k.props,T=C.helpers.getProducts();if(C.loading===!1)return T.length===0?null:$`
            <${k.templates.title} />
            <${k.templates.productList} />
            <${k.templates.button} />
          `}},title:{render:$=>i?$`
            <div class="product-recommendations__title">
              <h2 class="title inline-richtext ${a}">${i}</h2>
            </div>
          `:$``},productList:{render:($,k)=>$`
        <slider-component class="slider-component-full-width">
          <${k.templates.products} />
          <${k.templates.carouselActions} />
        </slider-component>
      `},products:{render:($,k)=>{let L=k.props.helpers.getProducts();return $`<ul
          id="Slider-${s}"
          class="grid product-grid contains-card contains-card--product contains-card--standard grid--4-col-desktop grid--2-col-tablet-down slider slider--desktop slider--tablet grid--peek"
        >
          ${L.map((T,F)=>$`<li class="grid__item slider__slide scroll-trigger animate--slide-in">
                <${k.templates.product} key=${F} product=${T} />
              </li>`)}
        </ul> `}},product:{options:{productPageUrl($){return It($)}},render:($,k)=>{let C=k.props,L=C.product,T=C.helpers;return $`<div
          class="tagalys-section__slide"
          id="Slide-${L.id}"
          dangerouslySetInnerHTML=${{__html:D(L,T)}}
        />`}},carouselActions:{render:$=>{var k,C,L,T,F,B;return $`
        <div class="slider-buttons">
          <button
            type="button"
            class="slider-button slider-button--prev"
            name="previous"
            aria-label="${(L=(C=(k=window.theme)==null?void 0:k.strings)==null?void 0:C.accessibility)==null?void 0:L.previousSlide}"
            aria-controls="Slider-${s}"
          >
            <span class="svg-wrapper">
              <svg
                class="icon icon--arrow-right"
                aria-label="Icon arrow right"
                width="8"
                height="9"
                viewBox="0 0 8 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 4.43945H7" stroke="currentColor"></path>
                <path d="M3.28711 0.787109L7.00015 4.50015L3.28711 8.2132" stroke="currentColor"></path>
              </svg>
            </span>
          </button>
          <button
            type="button"
            class="slider-button slider-button--next"
            name="next"
            aria-label="${(B=(F=(T=window.theme)==null?void 0:T.strings)==null?void 0:F.accessibility)==null?void 0:B.nextSlide}"
            aria-controls="Slider-${s}"
          >
            <span class="svg-wrapper">
              <svg
                class="icon icon--arrow-right"
                aria-label="Icon arrow right"
                width="8"
                height="9"
                viewBox="0 0 8 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 4.43945H7" stroke="currentColor"></path>
                <path d="M3.28711 0.787109L7.00015 4.50015L3.28711 8.2132" stroke="currentColor"></path>
              </svg>
            </span>
          </button>
        </div>
      `}},button:{render:$=>c&&l?$`
            <div class="product-recommendations__button">
              <a href="${l}" class="button button--secondary">${c}</a>
            </div>
          `:$``}}},U=rs;var ns={widget:'[data-tagalys-widget="recommendations"]'},ls=e=>{var a,c,l,d,p,u,h;let t=(a=e==null?void 0:e.dataset)==null?void 0:a.recommendationId,s=(c=e==null?void 0:e.dataset)==null?void 0:c.productId,i=(d=(l=e==null?void 0:e.dataset)==null?void 0:l.limit)!=null?d:8;if(!t||!s){window.console.error("TWP | tagalysSimilarProducts | recommendationId or productId is missing");return}(h=(u=(p=window.Tagalys)==null?void 0:p.UIWidgets)==null?void 0:u.Recommendations)==null||h.init(ns.widget,{recommendationId:t,productId:s,templates:U(i,e),callbacks:{afterInitialRender:()=>{let b=e.querySelector("slider-component");b==null||b.reinitialiseSlider()}}})},Tt=e=>{W(()=>ls(e))};var os="product-recommendations-recently",cs={tagalysWidget:'[data-tagalys-widget="recommendations"]',prevButton:"[data-prev-btn]",nextButton:"[data-next-btn]",recommendedWrapper:"[data-recommended-wrapper]",recommendedSliderContainer:"[data-recommended-slider]",productCard:"[data-product-card]",sliderDesktop:".slider--desktop"},Y=e=>{let s=e.querySelector(`[data-section-type="${os}"]`).querySelector(cs.tagalysWidget);s&&Tt(s)};var X={searchInput:"[data-TWP-search-input]",featuredProductsWidget:'[data-tagalys-widget="featured-products-suggestions"]'},Ft=(e,t)=>{let i=t.props.helpers.getProducts();return e`<div>
    <ul class="TWP-predictive-search__results-list--products predictive-search__results-list list-unstyled">
      ${i.map(a=>e`
          <li class="predictive-search__list-item">
            <${t.templates.product} key=${a.id} product=${a} />
          </li>
        `)}
    </ul>
  </div>`},Mt=(e,t)=>{var p,u,h,b,S,$,k,C,L;let s=t.props,i=s.product,a=s.helpers,l=a.getTemplateOptions("product").productPageUrl(i),d=i.tags?(p=i.tags)==null?void 0:p.filter(T=>T.includes("label:")):[];return e`
    <a
      href=${l}
      class="predictive-search__item predictive-search__item--link-with-thumbnail link link--text product-card-wrapper-TWP"
    >
      ${i.featured_image?e`<img
            class="predictive-search__image"
            src="${i.featured_image.src}&width=340"
            srcset="
              ${i.featured_image.src}&width=160   160w,
              ${i.featured_image.src}&width=360   360w,
              ${i.featured_image.src}&width=533   533w,
              ${i.featured_image.src}&width=720   720w,
              ${i.featured_image.src}&width=940   940w,
              ${i.featured_image.src}&width=1066 1066w,
              ${i.featured_image.src}&width=2132 2132w
            "
            sizes="(min-width: 768px) 25vw, 30vw"
            width="${i.featured_image.width}"
            height="${i.featured_image.height}"
            alt="${(u=i.featured_image.alt)!=null?u:i.title}"
          />`:null}

      <div class="predictive-search__item-content">
        <span class="visually-hidden">${(S=(b=(h=window.theme)==null?void 0:h.strings)==null?void 0:b.accessibility)==null?void 0:S.vendor}</span>
        <div class="predictive-search__item-vendor caption-with-letter-spacing">${i.vendor}</div>

        <p class="predictive-search__item-heading paragraph--small">${i.title}</p>

        ${a.isProductOnSale(i.compare_at_price,i.price)?e`
              <p class="price price--on-sale">
                <div class="price__sale">
                  <span class="visually-hidden">${(k=($=window.theme)==null?void 0:$.strings)==null?void 0:k.regularPriceLabel}</span>
                  <s class="price-item price-item--regular">
                    ${a.formatCurrency(i.compare_at_price)}
                  </s>
                  <span class="visually-hidden">${(L=(C=window.theme)==null?void 0:C.strings)==null?void 0:L.salePriceLabel}</span>
                  <span class="price-item price-item--sale price-item--last">
                    ${a.formatCurrency(i.price)}
                  </span>
                </div>
              </p>
            `:e`
              <p class="price">
                <div class="price__regular">
                  <span class="price-item price-item--regular">${a.formatCurrency(i.price)}</span>
                </div>
              </p>
            `}
      </div>

      ${d.length>0?e`
            <div class="card__badge">
              ${d.map(T=>{let F=T.replace("label:","");return e`<span class="badge">${F}</span>`})}
            </div>
          `:""}
    </a>
  `},At=()=>{W(()=>{var s,i,a;if(!document.querySelector(X.searchInput))return;let t=window.theme.locale&&!window.theme.locale.primary?window.theme.locale.rootUrl:"";(a=(i=(s=window.Tagalys)==null?void 0:s.UIWidgets)==null?void 0:i.SearchSuggestions)==null||a.init(X.searchInput,{searchResultsURL:`${t}${window.theme.routes.search}`,templates:{widget:{options:{includeTagalysCSS:!1,request:{products:{limit:3},collections:{limit:5},pages:{limit:5}},inheritAlignmentElementWidth:!1,position(c,l){let d=c.parentElement,p=l.parentElement;return d.after(p),!1}}},hint:{render(c){return c``}},clickSuggestions:{render(c,l){var S,$,k,C,L,T;let p=l.props.helpers,u=p.getRecentAndPopularSearches(),h=u.recentSearches,b=u.popularSearches;return c`
              <div class="predictive-search__results-groups-wrapper">
                <div class="predictive-search__result-group">
                  ${h.length>0?c`
                        <div>
                          <h2 class="predictive-search__heading text-body caption-with-letter-spacing">
                            ${(k=($=(S=window.theme)==null?void 0:S.strings)==null?void 0:$.search)==null?void 0:k.recentSearches}
                          </h2>
                          <ul class="predictive-search__results-list list-unstyled">
                            ${h.map(F=>c`
                                <li>
                                  <a
                                    href=${p.getLink(F.queryString)}
                                    class="predictive-search__item link link--text"
                                  >
                                    <span
                                      class="predictive-search__item-heading predictive-search__item-query-result paragraph--small"
                                    >
                                      ${F.displayString}
                                    </span>
                                  </a>
                                </li>
                              `)}
                          </ul>
                        </div>
                      `:null}
                  ${b.length>0?c`
                        <div>
                          <h2 class="predictive-search__heading text-body caption-with-letter-spacing">
                            ${(T=(L=(C=window.theme)==null?void 0:C.strings)==null?void 0:L.search)==null?void 0:T.popularSearches}
                          </h2>
                          <ul class="predictive-search__results-list list-unstyled">
                            ${b.map(F=>c`
                                <li>
                                  <a
                                    href=${p.getLink(F.queryString)}
                                    class="predictive-search__item link link--text"
                                  >
                                    <span
                                      class="predictive-search__item-heading predictive-search__item-query-result paragraph--small"
                                    >
                                      ${F.displayString}
                                    </span>
                                  </a>
                                </li>
                              `)}
                          </ul>
                        </div>
                      `:null}
                </div>
                <div class="predictive-search__result-group">
                  <${l.templates.featuredProductsSuggestions} />
                </div>
              </div>
            `}},featuredProductsSuggestions:{render(c){return c`<div
              className="featured-products-suggestions featured_products-wrapper"
              data-tagalys-widget="featured-products-suggestions"
            ></div>`},callbacks:{afterInitialRender:()=>{var l,d;let c=(d=(l=window.theme)==null?void 0:l.tagalys)==null?void 0:d.featuredProductsWidget.id;c&&window.Tagalys.UIWidgets.SmartWidget.init(X.featuredProductsWidget,{widgetId:c,templates:{widget:{options:{limit:3,displayFormat:"grid",includeTagalysCSS:!1},render:(p,u)=>{let h=u.props,S=h.helpers.getProducts();if(h.loading===!1)return S.length===0?null:p` <${u.templates.products} /> `}},products:{render:(p,u)=>Ft(p,u)},product:{render(p,u){return Mt(p,u)}}}})}}},typeSuggestions:{render(c,l){var $,k,C,L,T,F,B,x,O,M,E,H;let d=l.props,p=d.helpers,u=p.getAPIResponse(),h=(k=($=u==null?void 0:u.metadata)==null?void 0:$.products)==null?void 0:k.total,b=d.helpers.getEnteredSearchQuery(),S=`${t}${window.theme.routes.search}?q=${b}`;return c`
              <div class="predictive-search__results-groups-wrapper">
                <!--------- TEXT SUGGESTIONS (collections and pages) --------->
                <div class="predictive-search__result-group">
                  ${p.hasTextSearchSuggestions()?c` <${l.templates.textSuggestions} /> `:null}
                </div>

                <!--------- PRODUCTS SUGGESTIONS --------->
                <div class="predictive-search__result-group">
                  <${l.templates.products} />
                </div>
              </div>

              <div class="predictive-search__search-for-button">
                ${h?c`
                      <p class="predictive-search__results-count caption-with-letter-spacing hide--max-md">
                        ${h===1?(F=(T=(L=(C=window.theme)==null?void 0:C.strings)==null?void 0:L.search)==null?void 0:T.resultsWithCount.one)==null?void 0:F.replace("{{ count }}",h):(O=(x=(B=window.theme)==null?void 0:B.strings)==null?void 0:x.search)==null?void 0:O.resultsWithCount.other.replace("{{ count }}",h)}
                      </p>
                    `:null}

                <a
                  href=${encodeURI(S)}
                  class="predictive-search__item predictive-search__item--term button button--primary animate-arrow"
                >
                  <span data-predictive-search-search-for-text>${(H=(E=(M=window.theme)==null?void 0:M.strings)==null?void 0:E.search)==null?void 0:H.view_all}</span>
                </a>
              </div>
            `}},textSuggestions:{render(c,l){let u=l.props.helpers.getTextSuggestions();return c`
              ${u.map(h=>{var b;return c`
                  <div>
                    <h2 class="predictive-search__heading text-body caption-with-letter-spacing">
                      ${h.section_title}
                    </h2>
                    <ul class="predictive-search__results-list list-unstyled">
                      ${(b=h.items)==null?void 0:b.map(S=>c`
                          <li class="predictive-search__list-item">
                            <a href=${S.link} class="predictive-search__item link link--text" tabindex="-1">
                              <span
                                class="predictive-search__item-heading predictive-search__item-query-result paragraph--small"
                              >
                                ${S.displayString}
                              </span>
                            </a>
                          </li>
                        `)}
                    </ul>
                  </div>
                `})}
            `}},products:{render(c,l){return Ft(c,l)}},product:{render(c,l){return Mt(c,l)}}},callbacks:{afterInitialRender:()=>{let c=document.querySelector(".section-header"),l=document.querySelector(".tagalys-search-suggestions");if(!c||!l)return;let d=window.innerHeight-c.getBoundingClientRect().bottom;l.style.maxHeight=`${d}px`}}})})};var j={widget:'[data-tagalys-widget="search-results"]',drawer:"[data-filters-drawer]",facetsVertical:"[data-facets-vertical]"},ds=e=>{var S,$,k,C,L,T,F,B,x,O,M,E,H,te,se,ie,ae,re,ne,le,oe,ce,de,pe,ue,he,me,fe,ve,ge,be,ye,_e,we,$e,ke,Se,Le,xe,Ie,Ce,Pe,Te,Fe,Me,Ae,qe,Oe,ze,Ee,Re,Be,We,He,Ve,Ne,De,Ue,je,Qe,Ze,Ge,Je,Ke,Ye,Xe,et,tt,st,it,at,rt,nt,lt,ot,ct,dt,pt,ut,ht,mt,ft,vt,gt,bt,yt,_t,wt;let t=e.querySelector(j.widget);if(!t)return;let s=window.matchMedia("(min-width: 990px)").matches,i=(S=t.dataset.limit)!=null?S:24,a=($=t.dataset)==null?void 0:$.noResultsWidget,c=(k=t.dataset.noResultsWidgetLimit)!=null?k:4,l=(C=t.dataset.filtersType)!=null?C:"horizontal",d=t.dataset.showVerticalFilters==="true",p=(L=t.dataset.searchFilterLabel)==null?void 0:L.toLowerCase(),u=t.dataset.showFilterResultsCount==="true",h=(T=t.dataset.defaultExpandedFilters)!=null?T:"",b=s?10:5;(wt=(B=(F=window.Tagalys)==null?void 0:F.UIWidgets)==null?void 0:B.SearchResults)==null||wt.init(j.widget,{templates:{widget:{options:{limit:i,includeTagalysCSS:!1},labels:{searchResults:{heading:{standard:(O=(x=window.theme)==null?void 0:x.strings.search)==null?void 0:O.titleWithCount,corrected:(E=(M=window.theme)==null?void 0:M.strings.search)==null?void 0:E.titleCorrected,partialMatches:(te=(H=window.theme)==null?void 0:H.strings.search)==null?void 0:te.titlePartialMatches,noResults:(ie=(se=window.theme)==null?void 0:se.strings.search)==null?void 0:ie.noResults}},filters:{heading:(oe=(le=(ne=(re=(ae=window.theme)==null?void 0:ae.strings)==null?void 0:re.search)==null?void 0:ne.filters)==null?void 0:le.heading)!=null?oe:"Filter",selected:(he=(ue=(pe=(de=(ce=window.theme)==null?void 0:ce.strings)==null?void 0:de.search)==null?void 0:pe.filters)==null?void 0:ue.selected)!=null?he:"{{ count }} selected",maxPrice:(be=(ge=(ve=(fe=(me=window.theme)==null?void 0:me.strings)==null?void 0:fe.search)==null?void 0:ve.filters)==null?void 0:ge.maxPrice)!=null?be:"The highest price is {{ price }}",from:(ke=($e=(we=(_e=(ye=window.theme)==null?void 0:ye.strings)==null?void 0:_e.search)==null?void 0:we.filters)==null?void 0:$e.from)!=null?ke:"From",to:(Ce=(Ie=(xe=(Le=(Se=window.theme)==null?void 0:Se.strings)==null?void 0:Le.search)==null?void 0:xe.filters)==null?void 0:Ie.to)!=null?Ce:"To",reset:(Ae=(Me=(Fe=(Te=(Pe=window.theme)==null?void 0:Pe.strings)==null?void 0:Te.search)==null?void 0:Fe.filters)==null?void 0:Me.reset)!=null?Ae:"Reset",clear:(Re=(Ee=(ze=(Oe=(qe=window.theme)==null?void 0:qe.strings)==null?void 0:Oe.search)==null?void 0:ze.filters)==null?void 0:Ee.clear)!=null?Re:"Clear",clearFilter:(Ne=(Ve=(He=(We=(Be=window.theme)==null?void 0:Be.strings)==null?void 0:We.search)==null?void 0:He.filters)==null?void 0:Ve.clearFilter)!=null?Ne:"Remove",clearAll:(Ze=(Qe=(je=(Ue=(De=window.theme)==null?void 0:De.strings)==null?void 0:Ue.search)==null?void 0:je.filters)==null?void 0:Qe.clearAll)!=null?Ze:"Remove all",apply:(Xe=(Ye=(Ke=(Je=(Ge=window.theme)==null?void 0:Ge.strings)==null?void 0:Je.search)==null?void 0:Ke.filters)==null?void 0:Ye.apply)!=null?Xe:"Apply",label:(at=(it=(st=(tt=(et=window.theme)==null?void 0:et.strings)==null?void 0:tt.search)==null?void 0:st.filters)==null?void 0:it.label)!=null?at:"Filter",buttonLabel:(ct=(ot=(lt=(nt=(rt=window.theme)==null?void 0:rt.strings)==null?void 0:nt.search)==null?void 0:lt.filters)==null?void 0:ot.buttonLabel)!=null?ct:"Filter"},sortOptions:{label:(ut=(pt=(dt=window.theme)==null?void 0:dt.strings)==null?void 0:pt.search)==null?void 0:ut.sortBy},resultsWithCount:{one:(vt=(ft=(mt=(ht=window.theme)==null?void 0:ht.strings)==null?void 0:mt.search)==null?void 0:ft.resultsWithCount)==null?void 0:vt.one,other:(_t=(yt=(bt=(gt=window.theme)==null?void 0:gt.strings)==null?void 0:bt.search)==null?void 0:yt.resultsWithCount)==null?void 0:_t.other}},render(o,r){let f=r.props.helpers;return f.isInitialLoading()?o` <${r.templates.loader} /> `:f.hasNoSearchResults()&&!f.hasAnyFiltersApplied()?o` <${r.templates.noResults} /> `:l==="vertical"?o`
              <${r.templates.header} />

              <${r.templates.filtersVerticalCount} />

              <div class="facets-vertical">
                <${r.templates.filtersVertical} />

                <div class="product-grid-container" id="ProductGridContainer">
                  <div class="active-facets-TWP active-facets active-facets-desktop">
                    <${r.templates.appliedFilters} />
                  </div>
                  <div class="template-search__results collection TWP-collection" id="product-grid">
                    <${r.templates.products} />
                    <${r.templates.productListFooter} />
                  </div>
                </div>
              </div>
            `:o`
            <${r.templates.header} />
            <${r.templates.productListHeader} />
            <div class="product-grid-container" id="ProductGridContainer">
              <div class="template-search__results collection" id="product-grid">
                <${r.templates.products} />
                <${r.templates.productListFooter} />
              </div>
            </div>
          `}},loader:{render(o){return o`
            <div class="loading__spinner">
              <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">
                <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path" />
              </svg>
            </div>
          `}},header:{render(o,r){return o`
            <div class="template-search__header page-width scroll-trigger animate--fade-in">
              <${r.templates.heading} />
            </div>
          `}},heading:{render(o,r){let n=r.props,f=r.labels,v=n.helpers;return o`<h1 class="h5 center">${(()=>{var y,_,w,I;let g;return v.getQuery()?v.hasNoSearchResults()&&!v.hasAnyFiltersApplied()?g=f.searchResults.heading.noResults.replace("{{ terms }}",v.getQuery()):v.isPartialResults()?g=f.searchResults.heading.partialMatches.replace("{{searchTerm}}",v.getQuery()):v.isSpellingCorrectedQuery()?g=f.searchResults.heading.corrected.replace("{{originalSearchTerm}}",v.getOriginalQuery()).replace("{{resultsCount}}",v.getTotalProductsCount()).replace("{{correctedSearchTerm}}",v.getQuery()):g=f.searchResults.heading.standard.replace("{{resultsCount}}",v.getTotalProductsCount()).replace("{{searchTerm}}",v.getQuery()):g=(I=(w=(_=(y=window.theme)==null?void 0:y.strings)==null?void 0:_.search)==null?void 0:w.search)!=null?I:"Search",G(g)})()}</h1>`}},productListHeader:{render(o,r){return o`
            <div id="main-search-filters" class="facets-wrapper facets-wrapper-TWP page-width">
              <div class="TWP-facets-container--horizontal facets-container scroll-trigger animate--fade-in">
                <!---------- DESKTOP FILTERS ---------->
                <div class="facets small-hide">
                  <div class="facets__form">
                    <${r.templates.filters} type="desktop" />
                    <${r.templates.sortOptions} type="dropdown" />
                    <div class="product-count light" role="status">
                      <h2 class="product-count__text text-body">
                        <${r.templates.resultsCountLabel} />
                      </h2>
                    </div>
                  </div>
                </div>

                <!---------- MOBILE FILTERS ---------->
                <${r.templates.mobileFiltersContainer} />
              </div>
              <div class="active-facets-TWP active-facets active-facets-mobile medium-hide large-up-hide">
                <${r.templates.appliedFilters} />
              </div>
            </div>
          `}},mobileFiltersContainer:{render(o,r){let n=r.labels;return o`
            <menu-drawer
              class="mobile-facets__wrapper medium-hide large-up-hide"
              data-breakpoint="mobile"
              data-filters-drawer
            >
              <details class="mobile-facets__disclosure disclosure-has-popup">
                <summary class="mobile-facets__open-wrapper focus-offset">
                  <span class="mobile-facets__open">
                    <${r.templates.icon} type="filters" />

                    <span
                      class="mobile-facets__open-label button-label medium-hide large-up-hide caption--strong"
                      dangerouslySetInnerHTML=${{__html:n.filters.label}}
                    >
                    </span>
                    <span class="mobile-facets__open-label button-label small-hide">${n.filters.buttonLabel}</span>
                  </span>
                  <span tabindex="0" class="mobile-facets__close">
                    <span class="svg-wrapper">
                      <${r.templates.icon} type="close" />
                    </span>
                  </span>
                </summary>
                <div class="facet-filters-form">
                  <div class="mobile-facets">
                    <div class="mobile-facets__inner gradient">
                      <div class="mobile-facets__header">
                        <div class="mobile-facets__header-inner">
                          <h2 class="mobile-facets__heading medium-hide large-up-hide caption--strong">
                            <${r.templates.icon} type="filters" />
                            <span dangerouslySetInnerHTML=${{__html:n.filters.label}}></span>
                          </h2>
                          <h2 class="mobile-facets__heading small-hide">${n.filters.buttonLabel}</h2>
                          <p class="mobile-facets__count"><${r.templates.resultsCountLabel} /></p>
                        </div>
                      </div>

                      <${r.templates.filters} type="mobile" />
                    </div>
                  </div>
                </div>
              </details>
            </menu-drawer>
          `},callbacks:{afterInitialRender:()=>{let o=t.querySelector(j.drawer);o==null||o.setAttribute("data-initialized","")}}},filtersVerticalCount:{render(o,r){var n,f,v,m,g,y,_,w,I,A;return o`
            <div class="facets facets-vertical-count small-hide">
              <div class="facets-vertical-form">
                <div class="product-count-vertical" role="status">
                  <h2 class="product-count__text">
                    <${r.templates.resultsCountLabel} />
                  </h2>
                </div>
                <facets-vertical-open>
                  <button
                    class="facets-vertical-open__btn btn-none"
                    type="button"
                    aria-expanded="${d?"true":"false"}"
                    data-facets-vertical-open
                  >
                    <${r.templates.icon} type="filters" />

                    <span class="facets-vertical-open__label facets-vertical-open__label--show caption--strong">
                      ${(g=(m=(v=(f=(n=window.theme)==null?void 0:n.strings)==null?void 0:f.search)==null?void 0:v.filters)==null?void 0:m.filterButtonShow)!=null?g:"Filter"}
                    </span>

                    <span class="facets-vertical-open__label facets-vertical-open__label--hide caption--strong">
                      ${(A=(I=(w=(_=(y=window.theme)==null?void 0:y.strings)==null?void 0:_.search)==null?void 0:w.filters)==null?void 0:I.filterButtonHide)!=null?A:"Filter"}
                    </span>
                  </button>
                </facets-vertical-open>
              </div>
            </div>
          `}},filtersVertical:{render(o,r){return o`
            <aside
              class="facets-wrapper facets-wrapper-TWP facets-wrapper-TWP--vertical${d?"":" facets-wrapper-TWP--vertical-hidden"}"
              data-facets-vertical
            >
              <div class="facets small-hide">
                <div class="facets__form-vertical">
                  <${r.templates.filters} type="desktop" />
                </div>
              </div>

              <${r.templates.mobileFiltersContainer} />
            </aside>
          `},callbacks:{afterInitialRender:()=>{t.querySelector(j.facetsVertical)&&document.dispatchEvent(new CustomEvent("tagalys-search:vertical-filters-ready"))}}},filters:{render(o,r){let n=r.props,f=r.labels,v=n.helpers,m=v.getFilters();if(n.type==="mobile")return o`
              <div id="FacetsWrapperMobile" class="mobile-facets__main has-submenu gradient">
                <${r.templates.sortOptions} type="list" device="mobile" />

                ${m.map((_,w)=>o`<${r.templates.filterMobile} filter=${_} index=${w+1} />`)}

                <div class="mobile-facets__footer">
                  <div class="mobile-facets__clear-wrapper">
                    <button
                      type="button"
                      class="mobile-facets__clear underlined-link"
                      onClick=${()=>v.clearAllFilters()}
                    >
                      ${f.filters.clearAll}
                    </button>
                  </div>

                  <button
                    type="button"
                    class="button button--primary"
                    onclick=${_=>{var w,I;(I=(w=_.target.closest(".mobile-facets__wrapper"))==null?void 0:w.querySelector("summary"))==null||I.click()}}
                  >
                    ${f.filters.apply}
                  </button>
                </div>
              </div>
            `;let g=m.some(_=>_.id==="_derived_field_in_stock"),y={id:"_derived_field_in_stock",name:"Available",type:"checkbox",items:[{id:"true",name:"In Stock",count:0,selected:!1}]};return o`
            <div id="FacetsWrapperDesktop" class="facets__wrapper">
              <h2 class="facets__heading caption-large text-body" id="verticalTitle" tabindex="-1">
                ${f.filters.heading}
              </h2>

              ${l==="vertical"?o` <${r.templates.sortOptions} type="list" device="desktop" />`:""}
              ${g?"":o`<${r.templates.filter} filter=${y} index=${0} />`}
              ${m.map((_,w)=>o`<${r.templates.filter} filter=${_} index=${w+1} />`)}
            </div>
            ${l!=="vertical"?o`
                  <div class="active-facets-TWP active-facets active-facets-desktop">
                    <${r.templates.appliedFilters} />
                  </div>
                `:""}
          `}},filterMobile:{render(o,r){var I,A,z;let n=r.props,f=r.labels,v=n.helpers,m=n.filter,g=n.index,y="";if(m.type==="range"){let P=v.labelFormatter(m.display_format,m.max,m.currency);y=f.filters.maxPrice.replace("{{ price }}",P)}let _=h.includes(m.name.toLowerCase()),w=l==="vertical"&&((I=m.items)==null?void 0:I.length)>b;return o`
            <details
              id="Details-Mobile-${m.id}-search"
              class="mobile-facets__details${_?" menu-opening":""}"
              data-index="mobile-${g}"
              open=${_}
            >
              <summary class="mobile-facets__summary focus-inset caption--strong">
                <div>
                  <span>${m.name}</span>
                  <span class="mobile-facets__arrow">
                    <${r.templates.icon} type="chevron-down" />
                  </span>
                </div>
              </summary>

              <div
                id="FacetMobile-${g}-search"
                class="mobile-facets__submenu gradient parent-display"
                data-facets-container
              >
                ${m.type==="range"?o` <p class="mobile-facets__info">${y}</p>
                      <${r.templates.rangeSliderFilterItem} filter=${m} />`:o`
                      <div class="parent-wrap">
                        ${l=="vertical"&&m.name.toLowerCase()===p?o` <${r.templates.filterSearch} filter=${m} /> `:""}
                        <ul
                          class="facets-layout facets-layout-list facets-layout-list--text mobile-facets__list list-unstyled"
                          role="list"
                        >
                          ${(A=m.items)==null?void 0:A.map((P,R)=>o`<${r.templates.filterItemMobile}
                                filterItem=${P}
                                index=${R+1}
                                filterId=${m.id}
                                hasShowMore=${w}
                              />`)}
                        </ul>
                      </div>
                      ${l==="vertical"&&((z=m.items)==null?void 0:z.length)>b?o` <${r.templates.showMoreButton} filterId=${m.id} /> `:""}
                    `}

                <div class="mobile-facets__footer gradient">
                  <div class="mobile-facets__clear-wrapper">
                    <button
                      type="button"
                      class="mobile-facets__clear underlined-link"
                      onClick=${()=>v.clearFilter(m.id)}
                    >
                      ${f.filters.clear}
                    </button>
                  </div>

                  <button
                    type="button"
                    class="button button--primary"
                    onclick=${P=>{var R,q;(q=(R=P.target.closest(".mobile-facets__wrapper"))==null?void 0:R.querySelector("summary"))==null||q.click()}}
                  >
                    ${f.filters.apply}
                  </button>
                </div>
              </div>
            </details>
          `}},filter:{render(o,r){var I,A,z;let n=r.props,f=r.labels,v=n.helpers,m=n.filter,g=n.index,y=(I=m.items)==null?void 0:I.filter(P=>P.selected).length,_=f.filters.selected.replace("{{ count }}",y);if(m.type==="range"){let P=v.labelFormatter(m.display_format,m.max,m.currency);_=f.filters.maxPrice.replace("{{ price }}",P)}let w=l==="vertical"&&h.includes(m.name.toLowerCase());if(m.id=="_derived_field_in_stock"){let P=(A=m.items)==null?void 0:A.find(q=>q.id==="true"),R=q=>{q.stopPropagation(),P.selected?v.clearFilter(m.id,P.id):v.applyFilter(m.id,P.id)};if(P){let q=P.selected?"availability-auto-applied":"";return o`
                <div class="facets__summary facets__summary--availability ${q} caption--strong">
                  <label class="facet-availablity__wrapper" onclick=${R}>
                    <span>${P.name}</span>

                    <div class="facet-availablity__switch">
                      <input
                        class="visually-hidden"
                        type="checkbox"
                        name="${m.id}"
                        value="${P.name}"
                        id="Filter-${m.id}-${P.value}"
                        checked=${P.selected}
                      />
                      <span class="facet-availability__switch-slider"></span>
                    </div>
                  </label>
                </div>
              `}}return o`
            <details
              id="Details-${m.id}-search"
              class="${l==="vertical"?"facets__disclosure-vertical":"facets__disclosure disclosure-has-popup"}"
              data-index="${g}"
              open=${w}
            >
              <summary class="facets__summary caption--strong focus-offset">
                <div>
                  <span class="facets__summary-label">${m.name}</span>
                  <${r.templates.icon} type="caret" />
                </div>
              </summary>

              <div
                id="Facet-${g}-search"
                class="parent-display ${l==="vertical"?"facets__display-vertical":"facets__display"}"
                data-facets-container
              >
                ${l!=="vertical"?o`
                      <div class="facets__header">
                        <div>
                          <span class="facets__selected">${_}</span>
                        </div>

                        <button
                          type="button"
                          class="facets__reset link underlined-link"
                          onClick=${()=>v.clearFilter(m.id)}
                        >
                          ${f.filters.reset}
                        </button>
                      </div>
                    `:""}
                ${l=="vertical"&&m.name.toLowerCase()===p?o`<${r.templates.filterSearch} filter=${m} />`:""}

                <${r.templates.filterItems} filter=${m} />

                ${l==="vertical"&&((z=m.items)==null?void 0:z.length)>b?o` <${r.templates.showMoreButton} filterId=${m.id} /> `:""}
              </div>
            </details>
          `}},filterSearch:{render(o,r){var f,v,m,g,y;let n=r.props.filter;return o`
            <facets-search class="facets-search">
              <input
                class="facets-search__input caption--strong"
                type="text"
                name="${n.param_name}-search"
                placeholder="Search"
                data-facets-search-input
              />
              <p class="facets-search__no-results hidden" data-facet-search-no-results>
                ${(y=(g=(m=(v=(f=window.theme)==null?void 0:f.strings)==null?void 0:v.search)==null?void 0:m.filters)==null?void 0:g.noResults)!=null?y:"No matching results"}
              </p>
            </facets-search>
          `}},filterItems:{render(o,r){var y,_;let n=r.props,f=r.labels,v=n.helpers,m=l==="vertical"&&((y=n.filter.items)==null?void 0:y.length)>b,g="";if(n.filter.type==="range"){let w=v.labelFormatter(n.filter.display_format,n.filter.max,n.filter.currency);g=f.filters.maxPrice.replace("{{ price }}",w)}if(n.filter.type==="checkbox")return o` <fieldset
              class="facets-wrap parent-wrap ${l==="vertical"?"facets-wrap-vertical":""}"
            >
              <legend class="visually-hidden">${n.filter.name}</legend>
              <ul
                class="facets-layout facets-layout-list facets-layout-list--text list-unstyled ${l==="vertical"?"facets__list--vertical":"facets__list"}"
                role="list"
              >
                ${(_=n.filter.items)==null?void 0:_.map((w,I)=>o`<${r.templates.filterItem}
                      filterItem=${w}
                      index=${I+1}
                      filterId=${n.filter.id}
                      hasShowMore=${m}
                    />`)}
              </ul>
            </fieldset>`;if(n.filter.type==="range")return o` ${l==="vertical"?o`<div class="facets__header-vertical">
                    <span class="facets__selected">${g}</span>
                  </div>`:""}
              <${r.templates.rangeSliderFilterItem} filter=${n.filter} />`}},filterItem:{render(o,r){let n=r.props,f=n.helpers,v=n.filterItem,m=`Filter-${n.filterId}-${n.index}`,g=y=>{y.stopPropagation();let _=window.location.pathname!=="/collections/womens-coming-soon",w=n.filterId==="filter.v.m.custom.filtering_size"||n.filterId.toLowerCase().endsWith("size")&&!n.filterId.includes("prize"),I=f.getFilters().find(P=>P.id==="_derived_field_in_stock"),A=()=>{var P;if(I){let R=(P=I.items)==null?void 0:P.find(q=>q.id==="true");R&&!R.selected&&f.applyFilter("_derived_field_in_stock","true")}},z=()=>{var P;if(I){let R=(P=I.items)==null?void 0:P.find(q=>q.id==="true");R&&R.selected&&f.clearFilter("_derived_field_in_stock",R.id)}};n.filterItem.selected?(f.clearFilter(n.filterId,n.filterItem.id),w&&_&&(f.getFilters().filter(q=>q.id==="filter.v.m.custom.filtering_size"||q.id.toLowerCase().endsWith("size")&&!q.id.includes("prize")).some(q=>q.items&&q.items.some($t=>$t.selected&&$t.id!==n.filterItem.id))||z())):(f.applyFilter(n.filterId,n.filterItem.id),w&&_&&A())};return o`<li
            class="list-menu__item facets__item${n.hasShowMore&&n.index>b?" show-more-item hidden":""}"
            data-facets-item
          >
            <label
              for=${m}
              class="facets__label facet-checkbox caption-with-letter-spacing"
              onclick=${g}
            >
              <input
                type="checkbox"
                name=${n.filterId}
                value=${v.name}
                id=${m}
                checked=${v.selected}
              />

              <${r.templates.icon} type="square" />

              <div class="svg-wrapper">
                <${r.templates.icon} type="checkmark" />
              </div>

              <span class="facet-checkbox__text" aria-hidden="true">
                <span class="facet-checkbox__text-label" data-facet-label>${v.name}</span>
                ${u?`(${v.count})`:""}
              </span>
            </label>
          </li>`}},filterItemMobile:{render(o,r){let n=r.props,f=n.helpers,v=n.filterItem,m=`Filter-${n.filterId}-${n.index}`,g=y=>{var I;y.stopPropagation();let _=window.location.pathname!=="/collections/womens-coming-soon",w=n.filterId==="filter.v.m.custom.filtering_size"||n.filterId.toLowerCase().endsWith("size")&&!n.filterId.includes("prize");if(n.filterItem.selected)f.clearFilter(n.filterId,n.filterItem.id);else if(f.applyFilter(n.filterId,n.filterItem.id),w&&_){let A=f.getFilters().find(z=>z.id==="_derived_field_in_stock");if(A){let z=(I=A.items)==null?void 0:I.find(P=>P.id==="true");z&&!z.selected&&f.applyFilter("_derived_field_in_stock","true")}}};return o`<li
            class="mobile-facets__item list-menu__item${n.hasShowMore&&n.index>b?" show-more-item hidden":""}"
            data-facets-item
          >
            <label
              for=${m}
              class="facets__label mobile-facets__label caption-with-letter-spacing"
              onclick=${g}
            >
              <input
                class="mobile-facets__checkbox"
                type="checkbox"
                name=${n.filterId}
                value=${v.name}
                id=${m}
                checked=${v.selected}
              />

              <span class="mobile-facets__highlight"></span>

              <${r.templates.icon} type="square" />

              <${r.templates.icon} type="checkmark" />

              <span class="facet-checkbox__text" aria-hidden="true">
                <span class="facet-checkbox__text-label" data-facet-label>${v.name}</span>
                ${u?`(${v.count})`:""}
              </span>
            </label>
          </li>`}},rangeSliderFilterItem:{render(o,r){var m,g,y,_;let n=r.props,f=r.labels,v=`Filter-${n.filter.name}-`;return o`
            <div class="facets__price">
              <div class="hide" ref=${n.sliderRef} />
              <span class="field-currency caption--strong">${(g=(m=window.theme)==null?void 0:m.localization)==null?void 0:g.currencySymbol}</span>
              <div class="field">
                <input
                  id=${`${v}-GTE`}
                  class="field__input"
                  type="number"
                  value=${n.sliderInputValues[0]}
                  onblur=${n.onInputBlur}
                  onchange=${n.onMinChange}
                />
                <label class="field__label caption--strong" for=${`${v}-GTE`}>${f.filters.from}</label>
              </div>
              <span class="field-currency caption--strong">${(_=(y=window.theme)==null?void 0:y.localization)==null?void 0:_.currencySymbol}</span>
              <div class="field">
                <input
                  id=${`${v}-LTE`}
                  class="field__input"
                  type="number"
                  value=${n.sliderInputValues[1]}
                  onblur=${n.onInputBlur}
                  onchange=${n.onMaxChange}
                />
                <label class="field__label caption--strong" for=${`${v}-LTE`}>${f.filters.to}</label>
              </div>
            </div>
          `}},appliedFilters:{render(o,r){let n=r.props,f=r.labels,v=n.helpers,m=v.getAppliedFilters(!0);return m.length?o`
            ${m.map(g=>{var y;return g.type==="range"?o`
                  <button
                    type="button"
                    class="active-facets__button active-facets__button--light btn-none"
                    onClick=${()=>v.clearFilter(g.id)}
                  >
                    <span class="active-facets__button-inner button button--tertiary">
                      ${v.labelFormatter(g.display_format,g.selected_min,g.currency)} -
                      ${v.labelFormatter(g.display_format,g.selected_max,g.currency)}
                      <span class="svg-wrapper">
                        <${r.templates.icon} type="close-small" />
                      </span>
                      <span class="visually-hidden">${f.filters.clearFilter}</span>
                    </span>
                  </button>
                `:(y=g.items)==null?void 0:y.map(_=>o`
                  <button
                    type="button"
                    class="active-facets__button active-facets__button--light btn-none"
                    onClick=${()=>v.clearFilter(g.id,_.id)}
                  >
                    <span class="active-facets__button-inner button button--tertiary">
                      ${_.name}
                      <span class="svg-wrapper">
                        <${r.templates.icon} type="close-small" />
                      </span>
                      <span class="visually-hidden">${f.filters.clearFilter}</span>
                    </span>
                  </button>
                `)})}

            <div class="active-facets__button-wrapper">
              <button
                type="button"
                class="active-facets__button active-facets__button-remove underlined-link btn-none"
                onClick=${()=>v.clearAllFilters()}
              >
                <span class="active-facets__button-inner">
                  ${f.filters.clearAll}
                  <span class="svg-wrapper">
                    <${r.templates.icon} type="close-small" />
                  </span>
                </span>
              </button>
            </div>
          `:""}},sortOptions:{render(o,r){let n=r.props,f=r.labels,v=n.helpers,m=v.getSortOptions(),g=v.getAppliedSortOption(),y=w=>{w.target.type==="radio"&&!w.target.checked||v.applySortOption(w.target.value)},_=h.includes(f.sortOptions.label.toLowerCase());if(n.type==="list")return o`
              <details
                id="${n.device==="desktop"?"Details-sortby-search":"Details-Mobile-SortBy-search"}"
                class="${n.device==="desktop"?"facets__disclosure-vertical":"mobile-facets__details menu-opening"}"
                open=${_}
              >
                <summary
                  class="${n.device==="desktop"?"facets__summary":"mobile-facets__summary"} focus-inset caption--strong"
                  aria-label="${f.sortOptions.label} ${g.label}"
                >
                  <div>
                    <span class="facets__summary-label">${f.sortOptions.label}</span>
                    ${n.device==="desktop"?o` <${r.templates.icon} type="caret" /> `:o`<span class="mobile-facets__arrow">
                          <${r.templates.icon} type="chevron-down" />
                        </span>`}
                  </div>
                </summary>

                <div class="${n.device==="desktop"?"facets__display-vertical":"mobile-facets__submenu"}">
                  <ul class="facets-layout facets-layout-list list-unstyled">
                    ${m.map(w=>o` <${r.templates.sortOptionListItem}
                          sortOption=${w}
                          applySortOption=${y}
                          device=${n.device}
                        />`)}
                  </ul>
                </div>
              </details>
            `;if(n.type==="dropdown")return o`
              <div class="facet-filters sorting caption">
                <div class="facet-filters__field">
                  <h2 class="facet-filters__label caption-large text-body">
                    <label for="SortBy">${f.sortOptions.label}</label>
                  </h2>
                  <div class="select">
                    <select
                      class="facet-filters__sort select__select caption-large"
                      id="SortBy"
                      name="sort_by"
                      value=${g.id}
                      onchange=${y}
                    >
                      ${m.map(w=>o` <option value=${w.id}>${w.label}</option>`)}
                    </select>

                    <span class="svg-wrapper">
                      <${r.templates.icon} type="chevron-down" />
                    </span>
                  </div>
                </div>
              </div>
            `}},sortOptionListItem:{render(o,r){let n=r.props,f=n.sortOption;return o`
            <li class="list-menu__item facets__item">
              <label
                for=${`SortBy-${f.id}-${n.device}`}
                class="facets__label facet-checkbox caption-with-letter-spacing"
              >
                <input
                  id=${`SortBy-${f.id}-${n.device}`}
                  class="visually-hidden"
                  type="radio"
                  name="sort_by"
                  value=${f.id}
                  ${f.selected?"checked":""}
                  onchange=${n.applySortOption}
                />
                <${r.templates.icon} type="square" />
                <div class="svg-wrapper">
                  <${r.templates.icon} type="checkmark" />
                </div>
                ${f.label}
              </label>
            </li>
          `}},resultsCountLabel:{render(o,r){let n=r.props,f=r.labels,m=n.helpers.getTotalProductsCount(),g=m===1?f.resultsWithCount.one:f.resultsWithCount.other,y=g==null?void 0:g.replace("{{ count }}",m);return o`${y}`}},products:{render(o,r){let v=r.props.helpers.getProducts();return o`
            <ul class="grid product-grid grid--2-col-tablet-down grid--4-col-desktop" role="list">
              ${v.map(m=>o`<${r.templates.product} key=${m.id} product=${m} />`)}
            </ul>
          `}},product:{render(o,r){let n=r.props,f=n.product,v=n.helpers;return o`<li
            class="grid__item scroll-trigger animate--slide-in"
            dangerouslySetInnerHTML=${{__html:D(f,v)}}
          />`}},productListFooter:{render(o,r){return o` <${r.templates.pagination} /> `}},pagination:{render(o,r){return o`
            <div class="pagination-wrapper">
              <nav class="pagination" role="navigation" aria-label="Pagination">
                <${r.templates.paginationLinks} />
              </nav>
            </div>
          `}},paginationLinks:{options:{showNumberedPageLinks:!0,numberedPageLinksWindowSize:3,showPreviousPageLink:!0,showFirstPageLink:!1,showNextPageLink:!0,scrollTop:!0},render(o,r){let n=r.props,f=n.helpers,v=f.getPagesToDisplay(n.numberedPageLinksWindowSize),m=f.hasPreviousPage(),g=f.hasNextPage();return o`
            <ul class="pagination__list list-unstyled" role="list">
              ${n.showPreviousPageLink&&m?o` <li>
                    <button
                      type="button"
                      class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce"
                      aria-label="Previous page"
                      onclick=${f.goToPreviousPage}
                    >
                      <span class="svg-wrapper">
                        <${r.templates.icon} type="caret" />
                      </span>
                    </button>
                  </li>`:null}
              ${n.showNumberedPageLinks?v.map(y=>{let _=["pagination__item link"],w=y.jumpAfter;y.current&&_.push("pagination__item--current");let I=_.join(" ");return w?o`
                        <li>
                          <span class="pagination__item tt">...</span>
                        </li>
                      `:o`
                      <li>
                        <button
                          type="button"
                          class=${`${I}`}
                          onclick=${()=>{f.goToPage(y.page)}}
                        >
                          ${y.page}
                        </button>
                      </li>
                    `}):null}
              ${n.showNextPageLink&&g?o`
                    <li>
                      <button
                        type="button"
                        class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce"
                        aria-label="Next page"
                        onclick=${f.goToNextPage}
                      >
                        <span class="svg-wrapper">
                          <${r.templates.icon} type="caret" />
                        </span>
                      </button>
                    </li>
                  `:null}
            </ul>
          `}},showMoreButton:{render(o,r){var f,v,m,g,y,_,w,I,A,z;let n=r.props;return o`<show-more-button>
            <button
              class="button-show-more link underlined-link caption--strong"
              id="Show-More-${n.filterId}-tagalys-search"
              type="button"
            >
              <span class="label-show-more label-text">
                ${(y=(g=(m=(v=(f=window.theme)==null?void 0:f.strings)==null?void 0:v.search)==null?void 0:m.filters)==null?void 0:g.showMore)!=null?y:"Show More"}
              </span>
              <span class="label-show-less label-text hidden">
                ${(z=(A=(I=(w=(_=window.theme)==null?void 0:_.strings)==null?void 0:w.search)==null?void 0:I.filters)==null?void 0:A.showLess)!=null?z:"Show Less"}
              </span>
            </button>
          </show-more-button>`}},noResults:{options:{widgets:[{widgetId:a,options:{templates:U(c,t),callbacks:{afterInitialRender:()=>{let o=t.querySelector("slider-component");o==null||o.reinitialiseSlider()}}}}]},render(o,r){return o`
            <${r.templates.header} />

            ${a?o`
                  <div class="product-recommendations__wrapper">
                    <${r.templates.noResultsWidgets} />
                  </div>
                `:""}
          `}},icon:{render(o,r){let n=r.props;if(n.type==="filters")return o`<svg
              class="icon icon-filters"
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="13"
              fill="none"
              viewBox="0 0 13 13"
            >
              <g fill="currentColor" clip-path="url(#a)">
                <path
                  fill-rule="evenodd"
                  d="M11.665.83H1.077v10.59h10.588V.83ZM.371.126v12h12v-12h-12Z"
                  clip-rule="evenodd"
                />
                <path
                  d="M3.444 4.949h4.197a.824.824 0 1 0 0-.706H3.444v.706ZM4.268 8.83a.824.824 0 0 0 .744-.47h4.197v-.706H5.012a.824.824 0 1 0-.744 1.177Z"
                />
              </g>
              <defs>
                <clipPath id="a"><path fill="#fff" d="M0 .125h13v12H0z" /></clipPath>
              </defs>
            </svg>`;if(n.type==="caret")return o`<svg class="icon icon-caret" viewBox="0 0 10 6">
              <path
                fill="currentColor"
                fill-rule="evenodd"
                d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708"
                clip-rule="evenodd"
              />
            </svg> `;if(n.type==="chevron-down")return o`<svg
              class="icon icon-chevron-down"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M4 6L8 10L12 6" stroke="currentColor" />
            </svg> `;if(n.type==="square")return o`<svg width="16px" height="16px" viewBox="0 0 16 16">
              <rect width="16" height="16" fill="none" stroke="currentColor" />
            </svg>`;if(n.type==="checkmark")return o`<svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              class="icon icon-checkmark"
              viewBox="0 0 12 9"
            >
              <path
                fill="currentColor"
                fill-rule="evenodd"
                d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z"
                clip-rule="evenodd"
              />
            </svg> `;if(n.type==="close")return o`<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17">
              <path
                fill="currentColor"
                d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"
              />
            </svg>`;if(n.type==="close-small")return o`<svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              class="icon icon-close-small"
              viewBox="0 0 12 13"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M8.486 9.33 2.828 3.67M2.885 9.385l5.544-5.77"
              />
            </svg>`}}},callbacks:{onSuccessfulAPICall:o=>{var v,m,g,y,_,w,I,A;let r=o.total,f=(r>0?`${(y=(g=(m=(v=window.theme)==null?void 0:v.strings)==null?void 0:m.search)==null?void 0:g.metaTitle)==null?void 0:y.results} - ${window.shopName}`:`${(A=(I=(w=(_=window.theme)==null?void 0:_.strings)==null?void 0:w.search)==null?void 0:I.metaTitle)==null?void 0:A.noResults} - ${window.shopName}`).replace("{{ count }}",r).replace("{{ term }}",o.query);return document.title=G(f),o}}})},qt=e=>{W(()=>{ds(e)})};var ps=()=>{class e extends HTMLElement{constructor(){super(),this.selectors={facetsVertical:"[data-facets-vertical]"},this.classes={facetsVerticalAreOpen:"facets-vertical-are-open",facetsHidden:"facets-wrapper-TWP--vertical-hidden"}}connectedCallback(){var s,i;this.button=this.querySelector("button"),this.facetsVertical=(s=this.closest(".shopify-section"))==null?void 0:s.querySelector(this.selectors.facetsVertical),this.facetsVertical?this.setInitialState():document.addEventListener("tagalys-search:vertical-filters-ready",()=>{var a;this.facetsVertical=(a=this.closest(".shopify-section"))==null?void 0:a.querySelector(this.selectors.facetsVertical),this.facetsVertical&&this.setInitialState()},{once:!0}),(i=this.button)==null||i.addEventListener("click",a=>{var c;a.preventDefault(),this.isOpen=!((c=this.facetsVertical)!=null&&c.classList.contains(this.classes.facetsHidden)),this.toggleFacetsVerticalVisibility(!this.isOpen),sessionStorage.setItem("facetsVerticalOpen",!this.isOpen)})}setInitialState(){var s;this.isOpen=!((s=this.facetsVertical)!=null&&s.classList.contains(this.classes.facetsHidden)),this.facetsVerticalState=sessionStorage.getItem("facetsVerticalOpen")?JSON.parse(sessionStorage.getItem("facetsVerticalOpen")):this.isOpen,this.toggleFacetsVerticalVisibility(this.facetsVerticalState)}toggleFacetsVerticalVisibility(s){var i,a;(i=this.button)==null||i.setAttribute("aria-expanded",s),(a=this.facetsVertical)==null||a.classList.toggle(this.classes.facetsHidden,!s),document.body.classList.toggle("facets-vertical-are-open",s)}}customElements.define("facets-vertical-open",e)},Ot=ps;var zt=(e,t=250)=>{let s;return(...i)=>{clearTimeout(s),s=setTimeout(()=>{s=null,e(...i)},t)}};var us=()=>{class e extends HTMLElement{constructor(){super();kt(this,"debouncedSearch",zt(()=>{var d,p;let i=this.facetsSearchInput.value;if(this.listItems.length<1)return;let a=0;this.listItems.forEach(u=>{var S;let h=u.querySelector(this.selectors.facetLabel),b=((S=h==null?void 0:h.textContent)==null?void 0:S.toLowerCase())||"";i===""||b.includes(i)?(u.classList.remove("hidden"),a++):u.classList.add("hidden")});let c=(d=this.facetsContainer)==null?void 0:d.querySelector(this.selectors.noSearchResults);c==null||c.classList.toggle("hidden",a>0);let l=(p=this.facetsContainer)==null?void 0:p.querySelector(this.selectors.facetsShowMoreButton);l==null||l.classList.toggle("hidden",a<=this.showMoreNumber)},250));this.selectors={facetsContainer:"[data-facets-container]",facetsItem:"[data-facets-item]",facetLabel:"[data-facet-label]",facetSearchInput:"[data-facets-search-input]",noSearchResults:"[data-facet-search-no-results]",facetsShowMoreButton:"show-more-button"},this.classes={hidden:"hidden"}}connectedCallback(){var i,a,c;this.facetsSearchInput=this.querySelector(this.selectors.facetSearchInput),this.facetsContainer=(i=this.facetsSearchInput)==null?void 0:i.closest(this.selectors.facetsContainer),this.listItems=(a=this.facetsContainer)==null?void 0:a.querySelectorAll(this.selectors.facetsItem),this.showMoreNumber=window.matchMedia("(min-width: 990px)").matches?10:5,(c=this.facetsSearchInput)==null||c.addEventListener("input",this.debouncedSearch)}disconnectedCallback(){var i;(i=this.facetsSearchInput)==null||i.removeEventListener("input",this.debouncedSearch)}}customElements.define("facets-search",e)},Et=us;var ee=class extends HTMLElement{constructor(){super(),this.selectors={video:"video",control:"[data-video-control]"},this.classes={playing:"autoplay-video__control--playing"}}connectedCallback(){var t,s;this.video=this.querySelector(this.selectors.video),this.control=this.querySelector(this.selectors.control),(t=this.control)==null||t.addEventListener("click",this.togglePlayPause.bind(this)),(s=this.video)==null||s.addEventListener("click",()=>{window.matchMedia("(min-width: 750px)").matches||this.togglePlayPause()})}togglePlayPause(){this.video&&(this.video.paused?(this.video.play(),this.control.classList.add(this.classes.playing)):(this.video.pause(),this.control.classList.remove(this.classes.playing)))}};customElements.define("autoplay-video",ee);(e=>{window.NodeList&&!NodeList.prototype.forEach&&(NodeList.prototype.forEach=Array.prototype.forEach),document.addEventListener("DOMContentLoaded",()=>{var t,s,i,a,c,l;let d={logLevel:(t=e==null?void 0:e.logLevel)!=null?t:"silent",ignoreHidden:(s=e==null?void 0:e.ignoreHidden)!=null?s:!1,minBandwidth:e!=null&&e.minBandwidth?Number(e.minBandwidth):0,reduceData:(i=e==null?void 0:e.reduceData)!=null?i:!1},p=(x,O="")=>{d.logLevel==="verbose"&&window.console.log(`lazyvids: ${x}`,O)},u=(x,O="")=>{d.logLevel!=="silent"&&window.console.warn(`lazyvids: ${x}`,O)},h=typeof window.IntersectionObserver=="function",b;if(d.reduceData&&d.minBandwidth&&(((a=navigator.connection)==null?void 0:a.downlink)<d.minBandwidth||(c=navigator.connection)!=null&&c.saveData)){u(`Slow connection (${(l=navigator.connection)==null?void 0:l.downlink}mbps). Lazy autoplay disabled.`);return}let S=x=>{x.muted=!0,x.autoplay=!0,x.play()!==void 0?x.play().then(()=>x.dataset.lazyvids="loaded").catch(O=>u("Autoplay blocked by browser for:",x)):x.dataset.lazyvids="loaded"},$=x=>{var O,M;if(((O=x.style)==null?void 0:O.display)==="none"||d.ignoreHidden&&((M=x.style)==null?void 0:M.visibility)==="hidden")return!1;let E=getComputedStyle(x);return E.getPropertyValue("display")==="none"||d.ignoreHidden&&E.getPropertyValue("visibility")==="hidden"?!1:x.parentNode&&x.parentNode!==document?$(x.parentNode):!0},k=(x,O)=>{x.forEach(M=>{window.requestAnimationFrame(()=>{let E=M.target;M.isIntersecting!==!1&&$(E)!==!1&&(S(E),O.unobserve(E))})})};h&&(b=new IntersectionObserver(k));let C=x=>{if(h===!1){S(x),u("Unsupported browser. Lazy autoplay disabled.");return}x.dataset.lazyvids="unloaded",b.observe(x)},L="video[data-lazyvids]:not([data-lazyvids=loaded]):not([data-lazyvids=false])",T=document.querySelectorAll(L);p(`Initialised \u2014 ${T.length} ${T.length===1?"video":"videos"} detected`),T.forEach(x=>C(x));let F=x=>{x.forEach(O=>{O.addedNodes.forEach(M=>{if(M.tagName==="VIDEO"&&M.dataset.lazyvids!==void 0&&M.dataset.lazyvids!=="loaded"&&M.dataset.lazyvids!=="false"){C(M);return}M.hasChildNodes()!==!1&&M.querySelectorAll(L).forEach(E=>C(E))})})},B={childList:!0,subtree:!0};new MutationObserver(F).observe(document,B)})})(window.lazyvidsConfig||{});var Rt={shopifySections:".shopify-section",tagalysSearchResults:'[data-tagalys-widget="search-results"]'},Q={header:"section-header",productRecommendations:"product-recommendations-recently",sectionCollection:"section-collection",sectionSearch:"main-search"};document.addEventListener("DOMContentLoaded",()=>{N(),xt(),W(()=>{var s;(s=window.Tagalys)!=null&&s.Analytics&&typeof window.Tagalys.Analytics.trackPlatformEvents=="function"&&window.Tagalys.Analytics.trackPlatformEvents()}),At(),document.querySelectorAll(Rt.shopifySections).forEach(s=>{if(s.classList.contains(Q.header)){Lt(s);return}if(s.classList.contains(Q.productRecommendations)){Y(s);return}(s.classList.contains(Q.sectionCollection)||s.classList.contains(Q.sectionSearch))&&(Ot(),Et()),s.querySelector(Rt.tagalysSearchResults)&&qt(s)}),document.addEventListener("shopify:section:load",s=>{let i=s.detail.sectionId;if(i.includes("product_recommendations")){let a=document.getElementById(`shopify-section-${i}`);if(!a)return;Y(a)}}),document.querySelectorAll("[data-copy-button]").forEach(s=>{s.addEventListener("click",()=>St(void 0,null,function*(){let i=s.dataset.copyButton;if(i)try{yield navigator.clipboard.writeText(i),s.disabled=!0,setTimeout(()=>{s.disabled=!1},1500)}catch(a){window.console.error("Failed to copy text: ",a)}}))})});})();
